/* MONT CROCHU — theme.js
   Vanilla, no dependencies. Everything degrades to a working page without JS. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Focus trap ---------- */
  function trap(container, onEscape) {
    function keys(e) {
      if (e.key === 'Escape') { onEscape(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', keys);
    return function () { container.removeEventListener('keydown', keys); };
  }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Header behaviour ---------- */
  function header() {
    var el = $('[data-header]');
    if (!el) return;
    var last = window.scrollY;
    var solidAt = 40;
    function onScroll() {
      var y = window.scrollY;
      el.classList.toggle('is-solid', y > solidAt);
      if (el.hasAttribute('data-header-sticky-hide')) {
        var down = y > last && y > 260 && !document.body.classList.contains('is-locked');
        el.classList.toggle('header--hidden', down);
      }
      last = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Scroll lock ---------- */
  var lockY = 0;
  function lock() {
    lockY = window.scrollY;
    document.body.classList.add('is-locked');
    document.body.style.position = 'fixed';
    document.body.style.top = -lockY + 'px';
    document.body.style.width = '100%';
  }
  function unlock() {
    document.body.classList.remove('is-locked');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockY);
  }

  /* ---------- Menu ---------- */
  function menu() {
    var panel = $('[data-menu]');
    var open = $('[data-menu-open]');
    var close = $('[data-menu-close]');
    if (!panel || !open) return;
    var release;
    function show() {
      panel.classList.add('is-open');
      panel.removeAttribute('aria-hidden');
      open.setAttribute('aria-expanded', 'true');
      lock();
      release = trap(panel, hide);
      var first = $('a, button', panel);
      if (first) first.focus();
    }
    function hide() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      open.setAttribute('aria-expanded', 'false');
      unlock();
      if (release) release();
      open.focus();
    }
    open.addEventListener('click', show);
    if (close) close.addEventListener('click', hide);
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    drawer: null,
    overlay: null,
    release: null,
    init: function () {
      this.overlay = $('[data-overlay]');
      this.bind();
      var self = this;
      document.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-cart-open]');
        if (openBtn) { e.preventDefault(); self.open(); }
        if (e.target.closest('[data-cart-close]') || e.target === self.overlay) { self.close(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });
    },
    bind: function () {
      this.drawer = $('[data-cart-drawer]');
      if (!this.drawer) return;
      var self = this;
      $$('[data-line-change]', this.drawer).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-key');
          var qty = parseInt(btn.getAttribute('data-line-change'), 10);
          self.change(key, qty);
        });
      });
      $$('[data-line-input]', this.drawer).forEach(function (input) {
        input.addEventListener('change', function () {
          self.change(input.getAttribute('data-key'), parseInt(input.value, 10) || 0);
        });
      });
    },
    open: function () {
      if (!this.drawer) { window.location.href = window.routes.cart_url; return; }
      this.drawer.classList.add('is-open');
      this.drawer.removeAttribute('aria-hidden');
      if (this.overlay) this.overlay.classList.add('is-open');
      lock();
      this.release = trap(this.drawer, this.close.bind(this));
      var f = $('button, a', this.drawer);
      if (f) f.focus();
    },
    close: function () {
      if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.overlay) this.overlay.classList.remove('is-open');
      unlock();
      if (this.release) this.release();
    },
    refresh: function (openAfter) {
      var self = this;
      var wasOpen = self.drawer && self.drawer.classList.contains('is-open');
      return fetch(window.routes.root + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var host = document.getElementById('shopify-section-cart-drawer');
          if (host && data['cart-drawer']) {
            var tmp = document.createElement('div');
            tmp.innerHTML = data['cart-drawer'];
            var incoming = tmp.querySelector('#shopify-section-cart-drawer');
            host.innerHTML = incoming ? incoming.innerHTML : data['cart-drawer'];
          }
          self.bind();
          if (wasOpen || openAfter) { self.drawer = $('[data-cart-drawer]'); self.open(); }
          self.updateCount();
        });
    },
    updateCount: function () {
      fetch(window.routes.cart_url + '.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count > 0 ? cart.item_count : '';
          });
        });
    },
    change: function (key, quantity) {
      var self = this;
      return fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function () { return self.refresh(false); });
    },
    add: function (formData, opts) {
      var self = this;
      return fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) {
            toast(res.body.description || res.body.message || window.strings.addError);
            return;
          }
          return self.refresh(true);
        })
        .catch(function () { toast(window.strings.addError); });
    }
  };

  /* ---------- Add to cart forms ---------- */
  function addForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-add-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = window.strings.adding; }
      Cart.add(new FormData(form)).then(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; }
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function variants() {
    $$('[data-variant-root]').forEach(function (root) {
      var dataEl = $('[data-variant-json]', root);
      if (!dataEl) return;
      var list = JSON.parse(dataEl.textContent);
      var idInput = $('[data-variant-id]', root);
      var priceEl = $('[data-price]', root);
      var submit = $('[data-submit]', root);
      var gallery = document.querySelector('[data-gallery]');

      function current() {
        var chosen = $$('[data-option-index]', root)
          .filter(function (i) { return i.checked || i.tagName === 'SELECT'; })
          .map(function (i) { return i.value; });
        return list.filter(function (v) {
          return v.options.every(function (o, idx) { return o === chosen[idx]; });
        })[0];
      }

      function update() {
        var v = current();
        if (!v) {
          if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.textContent = window.strings.unavailable; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (v.price_html) {
          $$('[data-price]').forEach(function (el) { el.innerHTML = v.price_html; });
        }
        $$('[data-option-selected]', root).forEach(function (el) {
          var idx = parseInt(el.getAttribute('data-option-selected'), 10);
          el.textContent = v.options[idx];
        });
        if (submit) {
          if (v.available) {
            submit.removeAttribute('aria-disabled');
            submit.textContent = window.strings.addToCart;
          } else {
            submit.setAttribute('aria-disabled', 'true');
            submit.textContent = window.strings.soldOut;
          }
        }
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (gallery && v.media_id) {
          var target = gallery.querySelector('[data-media-id="' + v.media_id + '"]');
          if (target && gallery.classList.contains('gallery--slider')) {
            gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
          } else if (target) {
            target.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
          }
        }
      }

      $$('[data-option-index]', root).forEach(function (input) {
        input.addEventListener('change', update);
      });
      update();
    });
  }

  /* ---------- Gallery ---------- */
  function gallery() {
    var g = $('[data-gallery]');
    if (!g) return;

    $$('.gallery__item img', g).forEach(function (img) {
      img.addEventListener('click', function (e) {
        if (window.innerWidth < 990) return;
        var zoomed = img.classList.toggle('is-zoomed');
        if (zoomed) {
          var r = img.getBoundingClientRect();
          var ox = ((e.clientX - r.left) / r.width) * 100;
          var oy = ((e.clientY - r.top) / r.height) * 100;
          img.style.transformOrigin = ox + '% ' + oy + '%';
        } else {
          img.style.transformOrigin = '';
        }
      });
    });

    var dots = $('[data-gallery-dots]');
    if (dots && g.classList.contains('gallery--slider')) {
      var items = $$('.gallery__item', g);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > 0.6) {
            var i = items.indexOf(entry.target);
            $$('.gallery__dot', dots).forEach(function (d, di) {
              d.setAttribute('aria-current', di === i ? 'true' : 'false');
            });
          }
        });
      }, { root: g, threshold: [0.6] });
      items.forEach(function (i) { io.observe(i); });
    }
  }

  /* ---------- Sticky purchase bar ---------- */
  function stickyBuy() {
    var bar = $('[data-sticky-buy]');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor) return;
    document.body.classList.add('has-sticky-buy');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
    var trigger = $('[data-sticky-submit]', bar);
    if (trigger) {
      trigger.addEventListener('click', function () {
        var form = document.querySelector('form[data-add-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  /* ---------- Collection controls ---------- */
  function collection() {
    $$('[data-auto-submit]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
    var toggle = $('[data-layout-toggle]');
    var grid = $('[data-product-grid]');
    if (toggle && grid) {
      $$('button', toggle).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var cols = btn.getAttribute('data-cols');
          grid.style.setProperty('--cols', cols);
          $$('button', toggle).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          try { localStorage.setItem('mc-cols', cols); } catch (err) {}
        });
      });
      try {
        var saved = localStorage.getItem('mc-cols');
        if (saved) {
          grid.style.setProperty('--cols', saved);
          $$('button', toggle).forEach(function (b) {
            b.setAttribute('aria-pressed', b.getAttribute('data-cols') === saved ? 'true' : 'false');
          });
        }
      } catch (err) {}
    }
  }

  /* ---------- Hero reveal (single orchestrated moment) ---------- */
  function hero() {
    var h = $('[data-hero]');
    if (!h) return;
    var img = h.querySelector('img, video');
    function ready() { requestAnimationFrame(function () { h.classList.add('is-ready'); }); }
    if (!img || img.complete || img.tagName === 'VIDEO') ready();
    else { img.addEventListener('load', ready); img.addEventListener('error', ready); }
  }

  /* ---------- Recently viewed ---------- */
  function recentlyViewed() {
    var handle = document.body.getAttribute('data-product-handle');
    var key = 'mc-recent';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { list = []; }
    if (handle) {
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      list = list.slice(0, 8);
      try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
    }
    var host = $('[data-recently-viewed]');
    if (!host) return;
    var handles = list.filter(function (h) { return h !== handle; }).slice(0, 4);
    if (!handles.length) { host.remove(); return; }
    var query = handles.map(function (h) { return 'handle:' + h; }).join(' OR ');
    fetch(window.routes.search_url + '?section_id=recently-viewed&type=product&q=' + encodeURIComponent(query))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recent-grid]');
        if (inner && inner.children.length) {
          var target = host.querySelector('[data-recent-grid]');
          if (target) target.innerHTML = inner.innerHTML;
          host.hidden = false;
        } else {
          host.remove();
        }
      })
      .catch(function () { host.remove(); });
  }

  /* ---------- Quantity steppers ---------- */
  function quantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      var input = btn.parentElement.querySelector('input');
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-qty'), 10);
      var min = parseInt(input.getAttribute('min') || '1', 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Init ---------- */
  function init() {
    header();
    menu();
    Cart.init();
    addForms();
    variants();
    gallery();
    stickyBuy();
    collection();
    hero();
    quantity();
    recentlyViewed();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);

  window.MontCrochu = { cart: Cart, toast: toast };
})();
